module.exports = __webpack_public_path__ + "static/img/member.599fc08a.png";